/** Shared image decode / encode error messages (use with `new Error(...)`) */
export const ERR_IMAGE_FORMAT_UNRECOGNIZED = 'Image format unrecognized';
export const ERR_UNSUPPORTED_IMAGE_FORMAT = 'Unsupported image format';
